import jwtDecode from 'jwt-decode';

const ID_TOKEN_KEY = 'digita-id-token';

export function setIdToken(rawToken) {
  localStorage.setItem(ID_TOKEN_KEY, rawToken);
}

export function getIdToken() {
  const token = localStorage.getItem(ID_TOKEN_KEY);
  if (token === undefined || token === 'undefined') {
    return null;
  }
  return token;
}

export function isValidToken(rawToken) {
  if (rawToken == null) {
    return false;
  }

  const token = jwtDecode(rawToken);

  if (!token.exp) {
    return false;
  }

  const now = new Date() / 1000;
  if (now > token.exp) {
    return false;
  }

  return true;
}
